<script>
    export default {
        props: {
            filter: Object
        },
        data() {
            return {
                stoneId: '',
                apiUrl: `${Scoop.baseUrl}/selector/stones`,
            }
        },
        created() {
            this.stoneId = this.$root.filter.stoneId;
        },
        watch: {
            stoneId(value, old) {
                this.$root.filter.stoneId = value;

                // Start search if user selects an other option (than pre-loaded)
                if (!Array.isArray(value) && old !== '' && !_.isEqual(old, value) && value !== undefined) {
                    this.$root.startSearch();
                }
            },
            filter(value) {
                if (value.reset) {
                    this.stoneId = '';
                }
            }
        }
    }
</script>

<template>
    <div>
        <h5 class="m-t-md m-b-xs">Stone</h5>
        <div class="m-b">
            <model-picker
                    id="select-stones"
                    v-model="stoneId"
                    placeholder="Select stone"
                    :api-url="apiUrl"
                    :multiple="true"
            >
            </model-picker>
        </div>
    </div>
</template>
